import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Subscribe from '../../components/Subscribe/Subscribe';
import { RootState } from '../../store/config/types';
import { connect, ConnectedProps } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Iframe from '../../components/PlexoComponents/Iframe';
import PaymentMethod from '../../components/PlexoComponents/PaymentMethod';
import { amountHelper } from '../../utils/amountHelper';

interface PlexoProps {
  fullName: string;
  email: string;
}

declare global {
  interface Window {
    attachEvent: any;
  }
}

window.attachEvent = window.attachEvent || {};

const mapStateToProps = (state: RootState) => ({
  subscriber: state.subscriber,
  subscriptionTypes: state.subscriptionTypes,
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

type PropsType = PlexoProps & PropsFromRedux;

function Plexo({ fullName, email, subscriber, subscriptionTypes }: PropsType) {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();
  const canChooseSubscription = process.env.REACT_APP_CAN_CHOOSE_SUBSCRIPTION === 'true';

  const [externalId, setExternalId] = useState<string>('');
  const [subscriptionTypeId, setSubscriptionTypeId] = useState<string>('');
  const [mustSubscribe, setMustSubscribe] = useState<boolean>(false);
  const [detailsOpened, setDetailsOpened] = useState<boolean>(false);

  useEffect(() => {
    window.addEventListener('message', receiveMessage);

    return () => {
      window.removeEventListener('message', receiveMessage);
    };
  });

  const goBack = () => {
    navigate('/');
  };

  function receiveMessage(e: MessageEventInit) {
    if (e.data.message === 'redirectError') {
      navigate(`/result?errorCode=${e.data.payload}`);
    } else if (e.data.message === 'redirectSuccess') {
      setExternalId(e.data.payload.externalId);
      setSubscriptionTypeId(e.data.payload.subscriptionTypeId);
      setMustSubscribe(true);
    }
  }

  const duesAmount =
    subscriptionTypes.selectedSubscriptionType && subscriptionTypes.selectedSubscriptionType.recurrence !== 0
      ? subscriptionTypes.selectedSubscriptionType.recurrence
      : 0;

  return (
    <Container>
      <Subscribe
        mustSubscribe={mustSubscribe}
        externalId={externalId}
        subscriptionTypeId={subscriptionTypeId}
        replaceInstrument={false}
      />
      <div className="plexo">
        <div>
          <div
            onClick={() => setDetailsOpened(!detailsOpened)}
            className={`left-card ${detailsOpened ? 'left-card-open' : 'left-card-close'}`}
          >
            <div className="title">
              <div>Resumen de pago</div>
              <div className={detailsOpened ? 'chevron-down' : 'chevron-up'}></div>
            </div>
            {subscriptionTypes.selectedSubscriptionType !== null && (
              <>
                <div className="subtitle">{subscriptionTypes.selectedSubscriptionType.description}</div>
                <div className="personal-info">{subscriptionTypes.selectedSubscriptionType.name}</div>
                <div className="personal-info">{fullName}</div>
                <div className="personal-info">{email}</div>
                <div className="sub-card">
                  <div className="main-sub-card">
                    <div>
                      <div className={clsx('left-info', 'space-info')}>
                        {subscriptionTypes.selectedSubscriptionType.name}
                      </div>
                      {!canChooseSubscription && (
                        <div onClick={goBack} className={clsx('left-info', 'left-info-underline')}>
                          Cambiar la opción
                        </div>
                      )}
                    </div>
                    <div>
                      <div className={clsx('right-info', 'space-info')}>
                        {duesAmount > 0
                          ? `${duesAmount} ${duesAmount > 1 ? 'cuotas' : 'cuota'} de`
                          : ''}
                      </div>
                      <div className="right-info">
                        {amountHelper.subscriptionCurrencyToken(
                          subscriptionTypes.selectedSubscriptionType.currency,
                        )}{' '}
                        {subscriptionTypes.selectedSubscriptionType.subscriptionBaseCost}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="description-sub-card">
                  Recordá que recibirás cargos independientes, por lo que el saldo de tu tarjeta no
                  se verá comprometido más allá del valor de una cuota.
                </div>
              </>
            )}
          </div>
          <PaymentMethod />
        </div>
        <div className="right-card">
          <Iframe
            iframeRef={iframeRef}
            plexoUrl={subscriber.plexoUrl}
            replacePaymentMethodPlexoUrl={subscriber.replacePaymentMethodPlexoUrl}
          />
        </div>
      </div>
    </Container>
  );
}

export default connector(Plexo);
